import React from 'react'
import PropTypes from 'prop-types'

export const ProCheckbox = ({ children, isChecked, setIsChecked, name }) => {
  const handleChange = () => {
    setIsChecked(!isChecked)
  }

  return (
    <label className='procurated-checkbox'>
      <input
        type='checkbox'
        name={name}
        checked={isChecked}
        onChange={handleChange}
        id={name}
      />
      {children}
    </label>
  )
}

ProCheckbox.propTypes = {
  children: PropTypes.node,
  isChecked: PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
}

ProCheckbox.defaultProps = {
  children: null
}
